import { render, staticRenderFns } from "./CourseEdit.vue?vue&type=template&id=52a39af3&"
import script from "./CourseEdit.vue?vue&type=script&lang=js&"
export * from "./CourseEdit.vue?vue&type=script&lang=js&"
import style0 from "./CourseEdit.vue?vue&type=style&index=0&id=52a39af3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports